import { logging } from 'protractor';
import { Component } from '@angular/core';
import { DbmanagerService } from '../app/services/dbmanager.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [DbmanagerService]
})
export class AppComponent {
  title = 'findme';

  constructor(public dbservice: DbmanagerService) {

   }

   getVisible() {
     if (this.dbservice.logged) {
       return 'visible' ;
     }
     return 'hidden' ;
   }

   getHeight() {
    if (this.dbservice.logged) {
      return '100%' ;
    }
    return '60%' ;
  }

  getWidth() {
    if (this.dbservice.logged) {
      return '84%' ;
    }
    return '40%' ;
  }

  getMargin() {
    if (this.dbservice.logged) {
      return '30px 30px 0px 30px' ;
    }
    return '0 auto' ;
  }

}
